import MinusCircle from './MinusCircle';

export default MinusCircle;
